<template>

	<form @submit.prevent="onSubmit" novalidate>

		<steps :current="2" :total="3" scan />

		<mdb-container>

			<h4 class="font-weight-bold text-dark mb-4 px-4">{{ $t('newApplication.coBorrowerAddress') }}</h4>

			<mdb-card>
				<mdb-card-body>

					<template v-for="(fieldData, fieldName) in getForm('2')">

						<form-field
							v-bind="checkForOptions(fieldName, fieldData)"
							v-model="vModels[fieldName]"
							:name="fieldName"
							:label="getLabel(fieldName)"
							:options="(options[fieldName]) ? options[fieldName] : fieldData.options"
							:error="errors[fieldName]"
							:locale="locale"
							:mask="getMask(fieldName, fieldData)"
							bootstrap
							@change="onChange"
						>

							<template
								v-if="fieldName === 'row'"
								v-slot:fields
							>

								<form-field
									v-for="(childData, childName) in fieldData.fields"
									:key="fieldName + '-' + childName"
									v-bind="checkForOptions(childName, childData)"
									v-model="vModels[childName]"
									:name="childName"
									:label="getLabel(childName)"
									:options="(options[childName]) ? options[childName] : childData.options"
									:error="errors[childName]"
									:locale="locale"
									:mask="getMask(childName, childData)"
									bootstrap
									@change="onChange"
								></form-field>

							</template>

						</form-field>

					</template>

				</mdb-card-body>
			</mdb-card>

			<div class="form-group button-row">

				<submit-btn
					type="button"
					color="primary"
					:loading="goingBack"
					@click="goBack({name: 'CoBorrowerStep1', params: $route.params})"
				>{{ $t('forms.back') }}</submit-btn>

				<submit-btn type="submit" :loading="submitting">{{ $t('forms.next') }}</submit-btn>

			</div>

		</mdb-container>

	</form>

</template>

<script>

	import CoBorrowerMixin from './CoBorrowerMixin';

	export default {

		mixins: [
			CoBorrowerMixin
		],

		data() {

			return {
				vModels: {
					country: null,
					address1: '',
					address2: '',
					province: null,
					city: '',
					postal: '',
					titleOwner: null,
					yearsAtCurHouse: '',
					coborrowerNote: ''
				},
				optionals: ['yearsAtCurHouse', 'coborrowerNote']
			};

		}

	};

</script>

<style lang="scss" scoped>

</style>
